import React, { Fragment } from 'react'
import estilos from './InstalacionesComponent.module.css'
import { ThemeProvider, createTheme } from '@mui/material/styles';

function InstalacionesComponent(props) {

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });
    let cadenaDomicilio = ''
    const arrayDomicilio = []
    if (props?.data?.informaciongeneralinstalacioncliente?.calle === 'Otro') arrayDomicilio.push(props?.data?.informaciongeneralinstalacioncliente?.otracalle)
    else arrayDomicilio.push(props?.data?.informaciongeneralinstalacioncliente?.calle)
    if (props?.data?.informaciongeneralinstalacioncliente?.numerointerior != null && props?.data?.informaciongeneralinstalacioncliente?.numerointerior != ''&& props?.data?.informaciongeneralinstalacioncliente?.colonia != 'null') arrayDomicilio.push(props?.data?.informaciongeneralinstalacioncliente?.numerointerior)
    else arrayDomicilio.push('S/N')
    if (props?.data?.informaciongeneralinstalacioncliente?.numeroexterior != null && props?.data?.informaciongeneralinstalacioncliente?.numeroexterior != ''&& props?.data?.informaciongeneralinstalacioncliente?.colonia != 'null') arrayDomicilio.push(props?.data?.informaciongeneralinstalacioncliente?.numeroexterior)
    else arrayDomicilio.push('S/N')

    if (props?.data?.informaciongeneralinstalacioncliente?.colonia != null && props?.data?.informaciongeneralinstalacioncliente?.colonia != '' && props?.data?.informaciongeneralinstalacioncliente?.colonia != 'null' ) arrayDomicilio.push(props?.data?.informaciongeneralinstalacioncliente?.colonia)
    if (props?.data?.informaciongeneralinstalacioncliente?.localidad != null && props?.data?.informaciongeneralinstalacioncliente?.localidad != ''&& props?.data?.informaciongeneralinstalacioncliente?.localidad != 'null') arrayDomicilio.push(props?.data?.informaciongeneralinstalacioncliente?.localidad)
    if (props?.data?.informaciongeneralinstalacioncliente?.municipioalcaldia != null && props?.data?.informaciongeneralinstalacioncliente?.municipioalcaldia != ''&& props?.data?.informaciongeneralinstalacioncliente?.municipioalcaldia != 'null') arrayDomicilio.push(props?.data?.informaciongeneralinstalacioncliente?.municipioalcaldia)
    if (props?.data?.informaciongeneralinstalacioncliente?.estado != null && props?.data?.informaciongeneralinstalacioncliente?.estado != ''&& props?.data?.informaciongeneralinstalacioncliente?.estado != 'null') arrayDomicilio.push(props?.data?.informaciongeneralinstalacioncliente?.estado)
    if (props?.data?.informaciongeneralinstalacioncliente?.codigopostal != null && props?.data?.informaciongeneralinstalacioncliente?.codigopostal != ''&& props?.data?.informaciongeneralinstalacioncliente?.codigopostal != 'null') arrayDomicilio.push(props?.data?.informaciongeneralinstalacioncliente?.codigopostal)
    for (const i in arrayDomicilio) {
        if (Number(i) === 0) {
            cadenaDomicilio += arrayDomicilio[i]
        } else if (Number(i) + Number(1) === arrayDomicilio.length) {
            cadenaDomicilio += ', ' + arrayDomicilio[i]
        } else {
            cadenaDomicilio += ', ' + arrayDomicilio[i]
        }
    }
    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div className={`${estilos.masterInfo}`}>
                    <div className={`${estilos.header} text-center`} style={props?.data.isbaja ? { background: '#DC3545' } : { background: '#8ABE3E' }}>
                        <h4>{props?.data?.tipoanexo.descripcion.toUpperCase()}</h4>
                        <h5 style={{ marginTop: '2%' }}><b>Alias: </b>{(props?.data?.informaciongeneralinstalacioncliente?.alias)?.toUpperCase()}</h5>
                    </div>
                    <div style={{ margin: 0, padding: 0 }}>
                        <h6 style={{ marginTop: 0, marginLeft: '4%', textAlign: 'left' }} ><b>Ubicación:</b></h6>
                        <p style={{ margin: '4%', marginTop: 0, textAlign: 'justify' }}>{cadenaDomicilio?.toUpperCase()}</p>
                        {props?.data?.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente?.length > 0 &&
                            <h6 style={{ textAlign: 'left', marginLeft: '4%' }}><b>Responsables de instalación:</b></h6>
                        }
                        {props?.data?.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente?.map(responsable =>
                            <div className='row mt-3' style={{ width: '95%', margin: 'auto' }} >
                                <div className='col-12 col-md-5' style={{ wordWrap: 'break-word', textAlign: 'left' }} > {responsable.nombreresponsable.toUpperCase()} </div>
                                <div className='col-12 col-md-2' style={{ wordWrap: 'break-word', textAlign: 'left' }} > {responsable.telefono} </div>
                                <div className='col-12 col-md-5 pe-0' style={{ wordWrap: 'break-word', textAlign: 'left' }} > {responsable.correoelectronico} </div>
                            </div>
                        )}
                    </div>
                </div>
            </ThemeProvider>
        </Fragment >
    )
}

export default InstalacionesComponent